import { InjectionToken } from '@angular/core';

export const PRODUCTION_MODE = new InjectionToken<string>('PRODUCTION_MODE');
